<div class=content>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
